import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import qs from 'qs';
import { handleRequestError } from '../../utils/request';
import { api } from '../index';
export var apiQueryDefaultImageListInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/general/default_image?".concat(qs.stringify(payload)));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiQueryDefaultImageListInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();